module.exports = __webpack_public_path__ + "static/media/momoAge.97185f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/locomo/momoAge.png
// module id = 1705
// module chunks = 1